import { EmptyState, Icon, Popover } from "@helmr/ui";
import { strings } from "./strings";
import s from "./shell.module.css";

/** No notifications API yet: an honest empty state and no unread badge. */
export function BellMenu() {
  return (
    <Popover
      label={strings.shell.notifications}
      minWidth={340}
      trigger={(p) => (
        <button {...p} className={s.ibtn} aria-label={strings.shell.notifications}><Icon name="bell" /></button>
      )}
    >
      <EmptyState compact icon="bell" title={strings.shell.notificationsEmptyTitle} description={strings.shell.notificationsEmptyBody} />
    </Popover>
  );
}
